import bchaddr from 'bchaddrjs';

var detectAddressFormat = bchaddr.detectAddressFormat;

export default{
    isValidAddress: function (address) {
        try{
            detectAddressFormat(address);
            return true;
        }catch (e) {
            return false;
        }
    }
};